import compose from 'utils/composeEnhancer'
import handleFeedbackStore from './handleFeedBackStore'

export default compose(handleFeedbackStore)
